import axios from 'axios';

import {
  openErrorPopup,
  openPopup,
  closePopup,
} from 'containers/App/actions';

import {
  FETCH_POINTS,
  FETCH_POINTS_SUCCESS,
  FETCH_POINTS_ERROR,
  TOGGLE_NOTIFICATION_POINT,
  TOGGLE_NOTIFICATION_POINT_SUCCESS,
  TOGGLE_NOTIFICATION_POINT_ERROR,
  TOGGLE_POINT_EDITING_STATE,
  SAVE_NOTIFICATION_POINT,
  SAVE_NOTIFICATION_POINT_SUCCESS,
  SAVE_NOTIFICATION_POINT_ERROR,
  CONFIRM_NOTIFICATION_POINT_CODE,
  CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS,
  CONFIRM_NOTIFICATION_POINT_CODE_ERROR,
  RESET_NOTIFICATION_POINT_CODE_VALIDATION,
  SEND_NOTIFICATION_POINT_CODE,
  SEND_NOTIFICATION_POINT_CODE_SUCCESS,
  SEND_NOTIFICATION_POINT_CODE_ERROR,
  TOGGLE_CONFIRMATION_CODE_POPUP,
  CONFIRMATION_POPUP_KEY,
  EDITING_POPUP_KEY,
} from './constants';

export const CONTAINER_NAME = 'HomeNotificationPoints';

export function fetchPointsStart() {
  return {
    CONTAINER_NAME,
    type: FETCH_POINTS,
  };
}

export function fetchPointsSuccess(data, accountConvergent) {
  return {
    CONTAINER_NAME,
    accountConvergent,
    data,
    type: FETCH_POINTS_SUCCESS,
  };
}

export function fetchPointsError(error) {
  return {
    CONTAINER_NAME,
    error,
    type: FETCH_POINTS_ERROR,
  };
}

export function toggleNotificationPointStart(notificationType) {
  return {
    CONTAINER_NAME,
    data: notificationType,
    type: TOGGLE_NOTIFICATION_POINT,
  };
}

export function toggleNotificationPointSuccess(data) {
  return {
    CONTAINER_NAME,
    data,
    type: TOGGLE_NOTIFICATION_POINT_SUCCESS,
  };
}

export function handleTogglingNotificationPointError(notificationType, error) {
  return {
    CONTAINER_NAME,
    error,
    data: notificationType,
    type: TOGGLE_NOTIFICATION_POINT_ERROR,
  };
}

export function toggleNotificationPointError(notificationType, error) {
  return (dispatch) => {
    dispatch(handleTogglingNotificationPointError(notificationType, error));
    dispatch(openErrorPopup());
  };
}

export function saveNotificationPointStart(type) {
  return {
    CONTAINER_NAME,
    data: type,
    type: SAVE_NOTIFICATION_POINT,
  };
}

export function saveNotificationPointSuccess(data) {
  return {
    CONTAINER_NAME,
    data,
    type: SAVE_NOTIFICATION_POINT_SUCCESS,
  };
}

export function handleSavingNotificationPointError(notificationType, error) {
  return {
    CONTAINER_NAME,
    error,
    data: notificationType,
    type: SAVE_NOTIFICATION_POINT_ERROR,
  };
}

export function saveNotificationPointError(notificationType, error) {
  return (dispatch) => {
    dispatch(handleSavingNotificationPointError(notificationType, error));
    dispatch(openErrorPopup());
  };
}

export function confirmNotificationPointCodeStart(notificationType) {
  return {
    CONTAINER_NAME,
    data: notificationType,
    type: CONFIRM_NOTIFICATION_POINT_CODE,
  };
}

export function confirmNotificationPointCodeSuccess(notificationType) {
  return {
    CONTAINER_NAME,
    data: notificationType,
    type: CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS,
  };
}

export function confirmNotificationPointCodeError(notificationType) {
  return {
    CONTAINER_NAME,
    data: notificationType,
    type: CONFIRM_NOTIFICATION_POINT_CODE_ERROR,
  };
}

export function sendNotificationPointCodeStart(notificationType) {
  return {
    CONTAINER_NAME,
    data: notificationType,
    type: SEND_NOTIFICATION_POINT_CODE,
  };
}

export function sendNotificationPointCodeSuccess(notificationType) {
  return {
    CONTAINER_NAME,
    data: notificationType,
    type: SEND_NOTIFICATION_POINT_CODE_SUCCESS,
  };
}

export function handleSendingNotificationPointCodeError(notificationType, error) {
  return {
    CONTAINER_NAME,
    error,
    data: notificationType,
    type: SEND_NOTIFICATION_POINT_CODE_ERROR,
  };
}

export function sendNotificationPointCodeError(notificationType, error) {
  return (dispatch) => {
    dispatch(handleSendingNotificationPointCodeError(notificationType, error));
    dispatch(openErrorPopup({
      message: 'settings.common.sendNotificationPointCodeError',
    }));
  };
}

export function resetNotificationPointCodeValidation(data) {
  return {
    CONTAINER_NAME,
    data,
    type: RESET_NOTIFICATION_POINT_CODE_VALIDATION,
  };
}

export function togglePointEditingStateForSpecificPoint(data) {
  return {
    CONTAINER_NAME,
    data,
    type: TOGGLE_POINT_EDITING_STATE,
  };
}

export function togglePointEditingState(data) {
  return (dispatch) => {
    dispatch(togglePointEditingStateForSpecificPoint(data));

    if (data.isEditing) {
      dispatch(openPopup(EDITING_POPUP_KEY));
    } else {
      dispatch(closePopup());
    }
  };
}

export function toggleConfirmationCodePopupForSpecificPoint(data) {
  return {
    CONTAINER_NAME,
    data,
    type: TOGGLE_CONFIRMATION_CODE_POPUP,
  };
}

const convergentConfig = { params: { isConvergent: true } };

export function fetchPoints() {
  return async (dispatch) => {
    dispatch(fetchPointsStart());

    try {
      const { data: { data, accountConvergent } } = await axios
        .get('/api/profile/settings/notifications/notificationpoints/', convergentConfig);

      dispatch(fetchPointsSuccess(data, accountConvergent));
    } catch (error) {
      dispatch(fetchPointsError(error.message));
    }
  };
}

export function toggleNotificationPoint(data) {
  return async (dispatch) => {
    dispatch(toggleNotificationPointStart(data.type));

    try {
      await axios.post('/api/profile/settings/notifications/enablenotificationpoint/', data, convergentConfig);

      dispatch(toggleNotificationPointSuccess(data));
    } catch (error) {
      dispatch(toggleNotificationPointError(data.type, error.message));
    }
  };
}

export function sendNotificationPointCode(type) {
  return async (dispatch) => {
    dispatch(sendNotificationPointCodeStart(type));

    try {
      await axios
        .post('/api/profile/settings/notifications/sendnotificationpointconfirmationcode/',
          { type }, convergentConfig);

      dispatch(sendNotificationPointCodeSuccess(type));
    } catch (error) {
      dispatch(sendNotificationPointCodeError(type, error.message));
    }
  };
}

export function toggleConfirmationCodePopup(data) {
  return async (dispatch) => {
    dispatch(toggleConfirmationCodePopupForSpecificPoint(data));

    if (data.isConfirmationOpened) {
      dispatch(openPopup(CONFIRMATION_POPUP_KEY));

      await dispatch(sendNotificationPointCode(data.type));
    } else {
      dispatch(closePopup());
    }
  };
}

export function confirmNotificationPointCode(data) {
  return async (dispatch) => {
    dispatch(confirmNotificationPointCodeStart(data.type));

    try {
      await axios.post('/api/profile/settings/notifications/confirmnotificationpointcode/', data, convergentConfig);

      dispatch(confirmNotificationPointCodeSuccess(data.type));

      await dispatch(toggleConfirmationCodePopup({
        type: data.type,
        isConfirmationOpened: false,
      }));
    } catch (error) {
      dispatch(confirmNotificationPointCodeError(data.type));
    }
  };
}

export function saveNotificationPoint(data) {
  return async (dispatch) => {
    dispatch(saveNotificationPointStart(data.type));

    try {
      await axios.post('/api/profile/settings/notifications/notificationpoint/', data, convergentConfig);

      if (data.value) {
        dispatch(saveNotificationPointSuccess(data));

        await dispatch(toggleConfirmationCodePopup({
          type: data.type,
          isConfirmationOpened: true,
        }));
      } else {
        dispatch(saveNotificationPointSuccess(data));
      }
    } catch (error) {
      dispatch(saveNotificationPointError(data.type, error.message));
    }
  };
}
